<app-skeleton *ngIf="loadingList" variant="card" [count]="1" label="Carregando a lista" data-testid="list-loading"></app-skeleton>

<div class="sf-card empty" *ngIf="loadListError" data-testid="list-error">
  <i class="fa fa-exclamation-triangle"></i>
  <p>Não foi possível carregar a lista.</p>
  <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="findById()" data-testid="btn-retry-list">
    <i class="fa fa-refresh"></i> Tentar de novo
  </button>
</div>

<ng-container *ngIf="!loadingList && !loadListError">
  <ng-container *ngIf="listType; else pickType">
    <header class="page-head page-head--sticky">
      <div class="page-head__identity">
        <span class="page-head__icon"><i class="fa fa-list"></i></span>
        <h1 class="page-head__title">{{ title }}</h1>
      </div>
      <div class="page-head__actions">
        <a *ngIf="listId" [routerLink]="['/lists/new']" class="sf-btn sf-btn--ghost sf-btn--icon-right">
          Nova lista <i class="fa fa-plus-circle"></i>
        </a>
        <button type="button" class="sf-btn sf-btn--secondary" (click)="back()" data-testid="btn-back-list">
          <i class="fa fa-arrow-left"></i> {{ listId ? 'Voltar' : 'Cancelar' }}
        </button>
        <button
          type="submit"
          form="list-form"
          class="sf-btn sf-btn--primary"
          [disabled]="formList.invalid"
          [appLoadingButton]="saving"
          data-testid="btn-save-new-list"
        >
          <i class="fa fa-save"></i> Salvar
        </button>
      </div>
    </header>

    <div class="notice notice--warning" *ngIf="listId && leadList?.importing">
      <i class="fa fa-spinner fa-spin"></i>
      <div class="notice__body">
        Os Leads da sua lista estão sendo importados. Assim que finalizar você será notificado.
      </div>
    </div>

    <form id="list-form" [formGroup]="formList" (submit)="save()">
      <section class="sf-card">
        <h2 class="section-title"><i class="fa fa-list"></i> Dados da lista</h2>

        <div class="field-grid">
          <div class="field field--wide">
            <label for="name">Nome</label>
            <input type="text" class="form-control" id="name" formControlName="name" #nameInput data-testid="input-new-list-name" />
            <small class="field-error" *ngIf="formList.get('name').errors?.required" data-testid="new-list-error-alert">
              Preencha o nome da lista
            </small>
            <small class="field-error" *ngIf="formList.get('name').errors?.minlength" data-testid="min-length-error-alert">
              O nome da lista deve ter pelo menos 5 caracteres
            </small>
          </div>
        </div>

        <dl class="def-grid" *ngIf="!isManual">
          <div class="def">
            <dt>Integração</dt>
            <dd>{{ integrationName }}</dd>
          </div>
          <div class="def">
            <dt>Evento</dt>
            <dd>{{ platformEventName }}</dd>
          </div>
        </dl>

        <!-- Campo Tags escondido a pedido do Misael (14/10/2026): sem serventia hoje e confunde o cliente.
             O FormControl 'tags' continua no formList e no payload (lista antiga mantém as tags). Para voltar, ver o histórico deste arquivo. -->

        <div class="field-grid" *ngIf="formList.get('manual').value">
          <div class="field field--wide">
            <label>Lista dinâmica?</label>
            <app-switcher
              id="dinamic_list"
              [checked]="dynamic"
              (checkedChange)="dynamic = $event; toggleDynamic()"
              ngbTooltip="Lista dinâmica permite que você crie seu funil, fazendo com que o Lead seja
              movimentado de uma lista dinâmica para outra. Quando uma lista é dinamica o lead será
              retirado de outras listas dinamicas, mantendo-se apenas na ultima lista de inserção."
            ></app-switcher>
            <span class="field-hint">
              Lista dinâmica permite que você crie seu funil, fazendo com que o Lead seja movimentado de uma
              lista dinâmica para outra. Quando uma lista é dinamica o lead será retirado de outras listas
              dinamicas, mantendo-se apenas na ultima lista de inserção.
            </span>
          </div>
        </div>
      </section>

      <section class="sf-card" *ngIf="integrationUrl && listType === 'manual'">
        <h2 class="section-title"><i class="fa fa-code"></i> Integração por formulário web</h2>
        <p class="section-hint">Use a URL abaixo num formulário do seu site para enviar leads direto para esta lista.</p>

        <div class="form-actions" style="justify-content: flex-start; flex-wrap: wrap;">
          <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="showFields = !showFields">
            Campos integração <i class="fa fa-question-circle"></i>
          </button>

          <button
            type="button"
            class="sf-btn sf-btn--primary sf-btn--sm"
            ngbTooltip="Copiar URL para utilizar em um formulário web"
            (click)="copy()"
            *ngIf="isUserValidated"
          >
            URL Integração <i class="fa fa-files-o"></i>
          </button>
        </div>

        <small class="d-block postback-token-notice" *ngIf="isUserValidated && postbackTokenState === 'loading'"
          data-testid="notice-postback-token-loading">
          Carregando o token de segurança da URL…
        </small>
        <small class="d-block postback-token-notice" *ngIf="isUserValidated && postbackTokenState === 'unavailable'"
          data-testid="notice-postback-token-unavailable">
          Não foi possível carregar o token de segurança: a URL será copiada sem ele. Recarregue a página para tentar de novo.
        </small>

        <div class="field-grid" *ngIf="showFields">
          <div class="field field--wide">
            <p class="title">Campos do formulário:</p>
            <p class="attributes">
              <span><b>(<i>*</i>)name:</b> Nome do lead. Obrigatório!</span>
              <span><b>(<i>*</i>)phone:</b> Telefone do lead. Obrigatório!</span>
              <span><b>email:</b> E-mail do lead</span>
              <span><b>pix_code:</b> Código do pix para geração da página copia e cola</span>
              <span><b>product_name:</b> Nome do produto que irá aparecer na página copia e cola</span>
              <span><b>product_price:</b> Valor do produto que irá aparecer na página copia e cola</span>
              <span><b>product_url:</b> URL de checkout do produto que irá aparecer na página copia e cola</span>
              <span><b>customized_url:</b> Url à ser enviada nas mensagens de SMS</span>
              <span><b>success_url:</b> Url de redirecionamento (Utilizar apenas em caso de formulário web)</span>
              <span *ngIf="user?.content_tag_enabled"><b>var1, var2, var3, var4, var5:</b> Você pode incluir estas variáveis para utilizar nas mensagens.
              Ambas as variáveis tem o limite de 100 caracteres.</span>
              <br />
              <span>(<i>*</i>) campos obrigatórios</span>
            </p>
          </div>
        </div>
      </section>

    </form>
  </ng-container>

  <ng-template #pickType>
    <header class="page-head">
      <div class="page-head__identity">
        <span class="page-head__icon"><i class="fa fa-list"></i></span>
        <h1 class="page-head__title">Tipo de Lista</h1>
      </div>
    </header>

    <section class="sf-card">
      <h2 class="section-title"><i class="fa fa-list"></i> Que tipo de lista?</h2>
      <div class="pick-grid pick-grid--2">
        <button type="button" class="pick" *ngIf="user.validated" (click)="setListType('manual')">
          <span class="pk-ic"><i class="fa fa-list"></i></span>
          <span class="pk-body">
            <span class="pk-t">Lista Manual</span>
            <span class="pk-s">Leads cadastrados à mão, por importação ou formulário web.</span>
          </span>
        </button>
        <button type="button" class="pick" (click)="setListType('automática')">
          <span class="pk-ic danger"><i class="fa fa-rocket"></i></span>
          <span class="pk-body">
            <span class="pk-t">Lista Automática</span>
            <span class="pk-s">Recebe leads automaticamente de uma integração.</span>
          </span>
        </button>
      </div>
    </section>
  </ng-template>
</ng-container>

<div class="notice import-summary"
     [attr.role]="importSummaryVariant === 'danger' ? 'alert' : 'status'"
     [ngClass]="'notice--' + importSummaryVariant"
     *ngIf="importSummaryMessage && listId && !loadingList && !loadListError"
     data-testid="import-summary">
  <i class="fa" [ngClass]="importSummaryIcons[importSummaryVariant]" aria-hidden="true"
     data-testid="import-summary-icon"></i>
  <div class="notice__body" data-testid="import-summary-text">{{ importSummaryMessage }}</div>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
          aria-label="Fechar o resumo da importação" title="Fechar"
          (click)="dismissImportSummary()" data-testid="btn-dismiss-import-summary">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
</div>

<app-leads *ngIf="listId && !loadListError"
           (onImport)="updateList($event)"
           [leadListId]="listId"
           [reload]="reloadLeads"
           [showPostbackButton]="listType !== 'manual'"
           [showImportButton]="!listId || !leadList?.importing"></app-leads>

<app-hidden-field name="id" [value]="integrationUrl"></app-hidden-field>
